<template>
  <div>
    <AssocAccountDialog ref="assocDialog" />

    <EditAccountDetailsDialog ref="editDialog" />

    <GenericReport
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      :adapterSpec="adapterSpec"
      :fetcher="fetchData"
      @rowClicked="openDetailsDialog"
    >
      <template v-slot:topbar-actions>
        <v-spacer />
        <OMenuButton :menuOpts="menuOpts">
          <template v-slot:default="{ on }">
            <v-btn v-on="on">Copiar emails...</v-btn>
          </template>
        </OMenuButton>
        <v-spacer />
        <v-btn color="primary" @click="assocRow">
          Associar Contato...
        </v-btn>
      </template>
    </GenericReport>
  </div>
</template>

<script>
import AssocAccountDialog from './AssocAccountDialog.vue'
import EditAccountDetailsDialog from '../../tools/gateman/EditAccountDetailsDialog.vue'
import { Customer, Account } from '@/models'
import { atMost, hasTag } from 'oderon-commons/src/utils'
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import { addTagColor } from 'oderon-vue/utils'

import Store from './Store'

addTagColor((tag) => {
  if (tag == 'medição') return 'purple'
})

export default {
  components: {
    AssocAccountDialog,
    EditAccountDetailsDialog,
    GenericReport
  },
  data() {
    return {
      adapterSpec: [
        { t: '|Nome', d: 'fullName', w: 200 },
        { t: '|Email', d: 'email', w: 300 },
        { t: '|Tags', d: 'tags', w: 400 },
        { t: '|Notas', d: 'comments', tdClass: 'whiteSpacePre', f: (x) => atMost(x, 250) }
      ]
    }
  },
  computed: {
    // isto é computed por causa do nome do cliente no title
    reportSpec() {
      return {
        code: 'clientContacts',
        title: 'Contatos: ' + Store.row.label,
        filters: [
          {
            type: 'Switch',
            prefix: 'includeInactive',
            label: 'Mostrar inativos'
          }
        ]
      }
    },

    menuOpts() {
      return [
        {
          text: '...com tag Aprovador',
          onClick: () => this.copyToClipboard('Aprovador')
        },
        {
          text: '...com tag Financeiro',
          onClick: () => this.copyToClipboard('Financeiro')
        },
        {
          text: '...com tag Recebimento',
          onClick: () => this.copyToClipboard('Recebimento')
        },
        {
          text: '...com tag Medição',
          onClick: () => this.copyToClipboard('Medição')
        }
      ]
    }
  },
  methods: {
    fetchData(filter) {
      let rows = Store.row.accounts || []
      if (!filter.includeInactive) {
        rows = rows.filter((x) => !hasTag(x, 'Desligado'))
      }

      return { rows, count: rows.length }
    },

    async assocRow() {
      let customerId = Store.row.id

      let res = await this.$refs.assocDialog.open()
      if (res === 'NEW') {
        res = await this.$refs.editDialog.open()
        if (res != null) {
          this.$loading(async () => {
            let acc = await Account.save(res)
            await Customer.associateAccount(customerId, acc.id)
            await Store.reload()
            this.$snack('Salvo com sucesso')
          })
        }
      } else if (res != null) {
        this.$loading(async () => {
          await Customer.associateAccount(customerId, res.id)
          await Store.reload()
          this.$snack('Salvo com sucesso')
        })
      }
    },

    async openDetailsDialog({ row }) {
      let res = await this.$refs.editDialog.open(row.id)
      if (res != null) {
        this.$loading(async () => {
          await Account.save(res)
          await Store.reload()
          this.$snack('Salvo com sucesso')
        })
      }
    },

    copyToClipboard(tag) {
      let accounts = Store.row.accounts || []
      accounts = accounts.filter((x) => {
        if (hasTag(x, 'Desligado')) return false
        return hasTag(x, tag)
      })

      if (accounts.length < 1) {
        return this.$snack(
          `Não existem contas com a tag "${tag}" para copiar`,
          { color: 'yellow' }
        )
      }

      const result = accounts.map((a) => a.email).join(', ')

      navigator.clipboard.writeText(result)
      this.$snack(`Emails "${tag}" (exceto desligados) copiados!`)
    }
  }
}
</script>

<style lang="sass">
.whiteSpacePre
  white-space: pre
</style>
